import { createContext, useState, useEffect } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [firmAuth, setFirmAuth] = useState(() => {
    const savedAuth = localStorage.getItem("firmAuth");
    return savedAuth ? JSON.parse(savedAuth) : null;
  });

  const [personnelAuth, setPersonnelAuth] = useState(() => {
    const savedAuth = localStorage.getItem("personnelAuth");
    return savedAuth ? JSON.parse(savedAuth) : null;
  });

  const logoutFirm = () => {
    setFirmAuth(null);
    localStorage.removeItem("firmAuth");
  };

  const logoutPersonnel = () => {
    setPersonnelAuth(null);
    localStorage.removeItem("personnelAuth");
  };

  useEffect(() => {
    if (firmAuth) {
      localStorage.setItem("firmAuth", JSON.stringify(firmAuth));
      // Clear personnelAuth when firmAuth logs in
      setPersonnelAuth(null);
      localStorage.removeItem("personnelAuth");
    } else {
      localStorage.removeItem("firmAuth");
    }
  }, [firmAuth]);

  useEffect(() => {
    if (personnelAuth) {
      localStorage.setItem("personnelAuth", JSON.stringify(personnelAuth));
      // Clear firmAuth when personnelAuth logs in
      setFirmAuth(null);
      localStorage.removeItem("firmAuth");
    } else {
      localStorage.removeItem("personnelAuth");
    }
  }, [personnelAuth]);

  // useEffect(() => {
  //   const handleTabClose = () => {
  //     localStorage.removeItem("firmAuth");
  //     localStorage.removeItem("personnelAuth");
  //     setFirmAuth(null);
  //     setPersonnelAuth(null);
  //   };

  //   window.addEventListener("beforeunload", handleTabClose);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleTabClose);
  //   };
  // }, []);

  return (
    <AuthContext.Provider
      value={{
        firmAuth,
        setFirmAuth,
        logoutFirm,
        personnelAuth,
        setPersonnelAuth,
        logoutPersonnel,
      }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
